<template>
  <div class = "main-container-content-nonEmptyState" id = "scrollingContainer" v-if = "loanCount !== 0">
    <div class = "businessTable" @scroll="loadMoreLoans">
        <v-data-table
            :headers="headers"
            :items="loans"
            :items-per-page="itemsPerPage"
            :header-props="{ sortIcon: null }"
            :hide-default-footer="true"
            mobile-breakpoint="0"
            item-key="_id"
        >
            <template v-slot:item.borrowerName="{ item }">
                {{ changeName(item.borrowerName)}}
            </template>
            <template v-slot:item.lenderInterestRate="{ item }">
                {{ item.lenderInterestRate}}%
            </template>
            <template v-slot:item.investedAmount="{ item }">
                &#x20B9;{{ item.investedAmount | localeAmountPaisa }}
            </template>
            <template v-slot:item.upcomingDueDate="{ item }">
                <span v-if="item.reassignmentStatus === 'reassigned'">
                    Loan Closed
                </span>
                <span v-else-if="item.upcomingDueDate">
                    {{ item.upcomingDueDate | formatDate }}
                </span>
                <span v-else-if="item.status === '0'">
                    Disbursement Pending
                </span>
                <span v-else>
                    Loan Closed
                </span>
            </template>
        </v-data-table>
    </div>
    <div class = "loaderContainer">
        <v-progress-circular
        v-if="isLoading"
        indeterminate
        color="#13285e"
        ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import lenderService from '@/services/lenderService'
export default {
    props: {
        loanCount: Number
    },
    data () {
        return {
            headers: [
                {
                    text: 'Borrower',
                    value: 'borrowerName',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Invested Amount',
                    value: 'investedAmount',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Interest rate',
                    value: 'lenderInterestRate',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                },
                {
                    text: 'Upcoming Due Date',
                    value: 'upcomingDueDate',
                    align: 'left',
                    sortable: false,
                    class: 'sticky-header'
                }
            ],
            loans: [],
            itemsPerPage: 10,
            page: 1,
            totalRecords: null,
            limitDocuments: 10,
            isLoading: false,
            temp: []
        }
    },
    mounted () {
        this.getLoansData()
        this.$store.commit('isLoading')
    },
    methods: {
        getLoansData () {
            if (this.loans.length !== this.totalRecords) {
                const query = 'itemsPerPage=' + this.limitDocuments + '&page=' + this.page
                this.isLoading = true
                lenderService.getLenderLoansV2(query).then((response) => {
                    if (response.status === 200) {
                        this.$store.commit('isNotLoading')
                        this.isLoading = false
                        this.temp.push(...response.data.borrowerData)
                        this.loans = [...this.temp]
                        for (let i = 0; i < this.loans.length; i++) {
                            let returnString
                            const oldDate = new Date(this.loans[i].upcomingDueDate)
                            if (oldDate < new Date()) {
                                if (oldDate.getDate() > new Date().getDate()) {
                                    returnString = (new Date(oldDate.setMonth((new Date()).getMonth())))
                                } else {
                                    returnString = (new Date(oldDate.setMonth((new Date()).getMonth() + 1)))
                                }
                                this.loans[i].upcomingDueDate = returnString
                            }
                        }
                        if (response.data?.totalCount?.totalRecords) {
                            this.totalRecords = response.data.totalCount.totalRecords
                        }
                        this.itemsPerPage = this.loans.length
                    }
                })
            }
        },
        loadMoreLoans (e) {
            var { scrollTop, clientHeight, scrollHeight } = e.target
            if (Math.ceil(scrollTop + clientHeight + 1) >= scrollHeight) {
                this.page += 1
                this.getLoansData()
            }
        },
        changeName (name) {
            return name.toLowerCase().split(' ').map(s => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .v-data-table__wrapper .sticky-header {
        background: #f2f6ff !important;
        position: sticky;
        top: 0;
    }
    ::v-deep .v-data-table__wrapper {
        overflow: unset;
    }
    .loaderContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .businessTable {
        max-height: 250px;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .businessTable::-webkit-scrollbar {
        width: 0 !important
    }

    ::v-deep .primary {
        background-color: #002fa7 !important;
        border-color: #002fa7 !important;
    }
    ::v-deep .v-pagination__item {
        height: 25px;
        min-width: 25px;
        font-size: 14px;
    }
    ::v-deep .v-pagination__navigation {
        height: 25px;
        width: 25px
    }
    ::v-deep .v-icon.v-icon {
        font-size: 14px;
    }
    // ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:last-child {
    //     border: none;
    // }
    // ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) {
    //     border: none;
    // }
    // ::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    //     border-bottom: none;
    // }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        color: #6a6a6a;
        font-size: 13px
    }
    ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        height: 38px;
        font-size: 13px
    }
    ::v-deep .v-data-table-header {
        background-color: #f2f6ff;
    }
    .pagination {
        padding-top: 20px;
    }
    ::v-deep .v-pagination {
      justify-content: flex-end;
    }
    ::v-deep .v-chip__content {
        font-size: 13px;
        display: flex;
        justify-content: center;
    }
    .v-chip.v-size--default {
        border-radius: 8px
    }
    .v-chip {
        display: inline-block;
    }
    .main-container-content-nonEmptyState {
        width: 68%;
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 1200px) {
        .main-container-content-nonEmptyState {
            width: 65%;
        }
    }
    @media (max-width:768px){
        .main-container-content-nonEmptyState {
            width: 85%;
        }
    }
    @media (max-width: 480px) {
        .main-container-content-nonEmptyState {
            width: 100%;
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
            font-size: 11px
        }
        ::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
            font-size: 11px
        }
        ::v-deep .v-chip__content {
            font-size: 11px;
        }
    }
</style>
